import {
  LOADER_START,
  LOADER_STOP,
  SET_SUCCESS_MESSAGE,
  SET_ERROR_MESSAGE,
} from 'constants/actionTypes';

const UiReducer = (state, action) => {
  switch (action.type) {
    case LOADER_START: {
      return { ...state, showLoader: action.showLoader };
    }
    case LOADER_STOP: {
      return { ...state, showLoader: action.showLoader };
    }
    case SET_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: action.successMessage,
      };

    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };

    default:
      return state;
  }
};

export default UiReducer;
